/**
 * Local dev auth bypass — trimmed copy of pioneer-event's devConfig.
 * - `vite dev` 에서 기본 ON. 끄려면 `VITE_PIONEER_DEV_BYPASS=0`
 * - 백엔드 `TYCOON_AUTH_DEV_BYPASS=1` 과 함께 쓰면 Telegram 없이 RPC 가능
 */
export function isDevBypassEnabled() {
  return import.meta.env.DEV && import.meta.env.VITE_PIONEER_DEV_BYPASS !== "0";
}

export function resolveAuthenticated(sessionUser: { id: string } | null | undefined) {
  if (isDevBypassEnabled()) return true;
  return Boolean(sessionUser);
}
